interface DataSourceBadgeProps {
  source: "api" | "mock";
  className?: string;
}

export function DataSourceBadge({ source, className = "" }: DataSourceBadgeProps) {
  if (source === "api") {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-success-soft px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-success ${className}`}>
        <span className="size-1.5 rounded-full bg-success" />
        Live
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-warning-soft px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-warning ${className}`}>
      <span className="size-1.5 rounded-full bg-warning" />
      Mock
    </span>
  );
}
